<template>
  <span class="printer-temperatures">
    <span v-if="temps[2]" :data-content="$t('printers.item.ext2')" class="text--500 ext2">{{temps[2]}} °C</span>
    <span v-if="temps[1]" :data-content="$t('printers.item.ext1')" class="text--500 ext1">{{temps[1]}} °C</span>
    <span v-if="temps[0]" :data-content="$t('printers.item.heatBed')" class="text--500 heat-bed">{{temps[0]}} °C</span>
    <span v-if="chamberTemp" :data-content="$t('printers.item.chamb')" class="text--500 chamb">{{chamberTemp}} °C</span>
  </span>
</template>

<script>
  export default {
    name: 'printer-temperatures',
    props: ['printer'],
    computed: {
      temps() {
        if (!this.printer.temps) {
          return [];
        }
        if (typeof this.printer.temps === 'string') {
          if (this.printer.temps === 'f') {
            return [];
          }
          try {
            return JSON.parse(this.printer.temps)
          } catch(e) {
            console.log('Failed to parse temperatures: ' + this.printer.temps);
          }
        }

        return this.printer.temps;
      },
      chamberTemp() {
        return this.temps[3] && this.temps[3][0]==='c' ? this.temps[3].substring(1) : 0;
      }
    }
  }
</script>